import { getWorkspaceLayoutSnapshot } from './getWorkspaceLayoutSnapshot';
import { buildWorkspaceLayoutPreset } from './utils';
import { logger } from 'modules/logger';

export async function captureWorkspaceLayoutPreset() {
  const snapshot = await getWorkspaceLayoutSnapshot();

  const preset = buildWorkspaceLayoutPreset(snapshot);

  logger.info('[WorkspaceLayoutManager] Captured workspace layout preset', preset);
  return preset;
}
